module.exports = __webpack_public_path__ + "img/reception.227423b3.svg";